import { JSX } from 'react';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { RightNavigation, RightNavigationProps } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

interface N10RightSideNavigationProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: RightNavigationProps;
}

export const Default = (props?: N10RightSideNavigationProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return props?.fields?.navigations ? (
    <RightNavigation
      data-elastic-exclude=""
      data-component={marketingRenderingName}
      navigations={props.fields.navigations}
    />
  ) : (
    <></>
  );
};
